import API from '../apiCreate'
import { getParams } from '../getParams'
import type { AxiosRequestConfig } from 'axios'
import {
  CRM_INTEGRATION_NAME,
  type MaxIntegrationUpdateConfigBody,
  type ResponseMaxIntegrationConfig,
  type ResponseMaxIntegrationUpdateConfig,
  type ResponseUpdateIntegrationConfig,
  type ResponseVkIntegrationConfig,
  type ResponseVkTestConnection,
} from './crm-integrations.types'
import type { VkIntegrationUpdateConfigBody } from './vk/vk.types'

type ApiRequestConfigWithGlobalAlertFlag = AxiosRequestConfig & {
  skipGlobalErrorAlert?: boolean
}

export const crmIntegrationsApi = {
  /** GET ?name=vkontakte */
  getConfig: (params: { name: typeof CRM_INTEGRATION_NAME.VKONTAKTE }) =>
    API.get<ResponseVkIntegrationConfig>(
      `integration/get-config${getParams(params)}`,
    ),

  getMaxConfig: () =>
    API.get<ResponseMaxIntegrationConfig>(
      `integration/get-config${getParams({ name: CRM_INTEGRATION_NAME.MAX })}`,
    ),

  /** POST ?name=vkontakte — статус подключения VK (роль влияет на ответ) */
  testConnection: (params: { name: typeof CRM_INTEGRATION_NAME.VKONTAKTE }) =>
    API.post<ResponseVkTestConnection>(
      `integration/test-connection${getParams(params)}`,
      undefined,
      { skipGlobalErrorAlert: true } as ApiRequestConfigWithGlobalAlertFlag,
    ),

  testMaxConnection: () =>
    API.post<ResponseVkTestConnection>(
      `integration/test-connection${getParams({ name: CRM_INTEGRATION_NAME.MAX })}`,
      undefined,
      { skipGlobalErrorAlert: true } as ApiRequestConfigWithGlobalAlertFlag,
    ),

  /** PUT ?name=vkontakte, body — плоский JSON без обёртки по name */
  updateConfig: (
    params: { name: typeof CRM_INTEGRATION_NAME.VKONTAKTE },
    data: VkIntegrationUpdateConfigBody,
  ) =>
    API.put<ResponseUpdateIntegrationConfig>(
      `integration/update-config${getParams(params)}`,
      data,
    ),

  updateMaxConfig: (data: MaxIntegrationUpdateConfigBody) =>
    API.put<ResponseMaxIntegrationUpdateConfig>(
      `integration/update-config${getParams({ name: CRM_INTEGRATION_NAME.MAX })}`,
      data,
    ),
}
